export default function Breadcrumb({ routeSegments }) {
  const lastIndex = routeSegments.length - 1;

  return (
    <div className="breadcrumb">
      <h1>{routeSegments[lastIndex]["name"]}</h1>
    </div>
  );
}
